let ViewportApi = function (_api, ___refs) {
  const THREE_D_MANAGER_CONSTANTS = require('../ThreeDManagerConstants'),
        ViewportApiInterface = require('../../../interfaces/api/ViewportApiInterface'),
        CameraApi = require('./CameraApi'),
        LightApi = require('./LightApi');
  
  let _threeDManager = ___refs.threeDManager,
      _viewportManager = ___refs.viewportManager,
      _viewportApiHelpers, _references, 
      _listeners = {};

  class ViewportApi extends ViewportApiInterface {
    
    constructor() {
      super();

      this.utils = _api.utils;
      this.EVENTTYPE = _api.viewports.EVENTTYPE;

      /**
       * The camera api.
       * 
       * @type {module:CameraApiSimple~CameraApi}
       */
      this.camera = new CameraApi(_api, {
        threeDManager: _threeDManager,
        viewportManager: _viewportManager,
        apiResponse: this.utils.APIResponse
      });
      
      /**
       * The light api.
       * 
       * @type {module:LightApiSimple~LightApi}
       */
      this.lights = new LightApi(_api, {
        threeDManager: _threeDManager,
        apiResponse: this.utils.APIResponse
      });

      _viewportApiHelpers = require('../../../helpers/api/ViewportApiHelpers').getInstance();
      
      _references = {
        THREE_D_MANAGER_CONSTANTS: THREE_D_MANAGER_CONSTANTS,
        EVENTTYPE: this.EVENTTYPE,
        threeDManager: _threeDManager,
        viewportManager: _viewportManager,
        apiResponse: this.utils.APIResponse,
        listeners: _listeners,
      };

      this.getRuntimeId = this.getRuntimeId.bind(this);
      this.getContainer = this.getContainer.bind(this);
      this.getScreenshot = this.getScreenshot.bind(this);
      
      this.render = this.render.bind(this);
      this.convertTo2D = this.convertTo2D.bind(this);
      this.onResize = this.onResize.bind(this);
      this.getSize = this.getSize.bind(this);

      this.pause = this.pause.bind(this);
      this.resume = this.resume.bind(this);
      this.reload = this.reload.bind(this);
      this.destroy = this.destroy.bind(this);

      this.addEventListener = this.addEventListener.bind(this);
      this.removeEventListener = this.removeEventListener.bind(this);

      this.getSettingDefinitions = this.getSettingDefinitions.bind(this);
      this.getSettings = this.getSettings.bind(this);
      this.getSetting = this.getSetting.bind(this);
      this.updateSettingAsync = this.updateSettingAsync.bind(this);
      this.updateSettingsAsync = this.updateSettingsAsync.bind(this);

      this.applyTransformation = this.applyTransformation.bind(this);
      this.resetTransformation = this.resetTransformation.bind(this);
      this.setLiveTransformation = this.setLiveTransformation.bind(this);

      this.updateSelected = this.updateSelected.bind(this);
      this.getSelected = this.getSelected.bind(this);
    }

    /** @inheritdoc */
    getRuntimeId() {
      return _threeDManager.runtimeId;
    }
    
    /** @inheritdoc */
    getContainer() {
      return _threeDManager.container;
    }

    /** @inheritdoc */
    getScreenshot() {
      return _threeDManager.renderingHandler.getScreenshot();
    }




    /** @inheritdoc */
    render() {
      _threeDManager.renderingHandler.render();
    }

    /** @inheritdoc */
    convertTo2D(position) {
      return _viewportApiHelpers.convertTo2D(_references, position);
    }

    /** @inheritdoc */
    onResize(width, height) {
      _threeDManager.cameraHandler.onResize(width, height);
      _threeDManager.renderingHandler.onResize(width, height);
    }
  
    /** @inheritdoc */
    getSize() {
      return _threeDManager.renderingHandler.getSize();
    }




    /** @inheritdoc */
    pause() {
      _threeDManager.pause();
    }

    /** @inheritdoc */
    resume() {
      _threeDManager.resume();
    }

    /** @inheritdoc */
    reload() {
      return _viewportApiHelpers.reload(_references);
    }

    /** @inheritdoc */
    destroy() {
      return _viewportApiHelpers.destroy(_references);
    }

    


    /** @inheritdoc */
    addEventListener(type, cb) {
      return _viewportApiHelpers.addEventListener(_references, type, cb);
    }

    /** @inheritdoc */
    removeEventListener(token) {
      return _viewportApiHelpers.removeEventListener(_references, token);
    }




    /** @inheritdoc */
    getSettingDefinitions() {
      return _viewportApiHelpers.getSettingDefinitions(_references);
    }

    /** @inheritdoc */
    getSettings(keys) {
      return _viewportApiHelpers.getSettings(_references, keys);
    }

    /** @inheritdoc */
    getSetting(k) {
      return _viewportApiHelpers.getSetting(_references, k);
    }

    /** @inheritdoc */
    updateSettingAsync(k, val) {
      return _viewportApiHelpers.updateSettingAsync(_references, k, val);
    }

    /** @inheritdoc */
    updateSettingsAsync(settings) {
      return _viewportApiHelpers.updateSettingsAsync(_references, settings);
    }
    
    


    /** @inheritdoc */
    applyTransformation(matrix) {
      return _viewportApiHelpers.applyTransformation(_references, matrix);
    }

    /** @inheritdoc */
    resetTransformation() {
      return _viewportApiHelpers.resetTransformation(_references);
    }

    /** @inheritdoc */
    setLiveTransformation(liveTransformations, duration) {
      return _viewportApiHelpers.setLiveTransformation(_references, liveTransformations, duration);
    }




    /** @inheritdoc */
    updateSelected(select, deselect) {
      throw new Error('This API function is not implemented by this viewport.');
    }

    /** @inheritdoc */
    getSelected() {
      throw new Error('This API function is not implemented by this viewport.');
    }
  }

  return new ViewportApi();
};

module.exports = ViewportApi;